<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <!-- Play system: soft-tinted icon chip (bg-light-* + text-* are already
           mapped to the Play palette), replacing the bootstrap-vue <b-avatar>. -->
      <span
        class="toast-icon flex-shrink-0 mr-75"
        :class="`bg-light-${variant}`"
      >
        <feather-icon
          :icon="icon"
          size="15"
          :class="`text-${variant}`"
        />
      </span>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small
            v-if="text"
            class="d-inline-block text-body"
            v-text="text"
          />
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto "
          @click="$emit('close-toast')"
        >
          <feather-icon
            v-if="!hideClose"
            icon="XIcon"
            class="text-body"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.toast-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
}

.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  font-family: var(--font-display);
  font-weight: 800;
  color: inherit;
}
</style>
